import * as THREE from 'three';
import { Line2 } from '../math/Line2';

const EPSILON = 0.00001;

export default class PointList {
    public points: THREE.Vector2[] = [];

    public addPoint(point: THREE.Vector2): number {
      this.points.push(point);
      return this.points.length - 1;
    }

    // 線分の間にあるポイントを取得. インデックス番号の配列を返す
    public getIndexesFromLine(line: Line2): number[] {
      // const rec = new rectangle(line.start, line.end);
      // const distance = line.distance();   // lineの距離
      // const delta = new THREE.Vector2();
      // line.delta(delta);      // line.start-endのベクトル

      // // lineベクトルからpointの距離がEPSILON以内なら点が乗っている判定
      // return this.points.reduce((acc: number[], value: any, index: any) => {
      //     if (rec.min.x - EPSILON < value.x && value.x <= rec.max.x + EPSILON && rec.min.y - EPSILON < value.y && value.y <= rec.max.y + EPSILON) {
      //         const point1 = line.start.clone().sub(this.points[index]);
      //         const dist = point1.cross(delta) / distance;

      //         if (Math.abs(dist) < EPSILON) {
      //             acc.push(index);
      //         }

      //         const v1 = value.clone().sub(line.start);

      //     }
      //     return acc;
      // }, []);

      const v1 = line.end.clone().sub(line.start);
      const l1 = line.end.distanceTo(line.start);

      return this.points.reduce((acc: number[], value: THREE.Vector2, index: any) => {
        const v2 = value.clone().sub(line.start);
        const l2 = value.distanceTo(line.start);
        const n = v2.dot(v1);

        // if (n == l1*l2 && l1 >= l2) {
        if (Math.abs(n - l1 * l2) < EPSILON && l1 >= l2) {
          acc.push(index);
        }

        return acc;
      }, []);
    }
}
